/** @jsxImportSource @emotion/react */
import { useMemo } from 'react';
import CustomChip from 'components/selects/CustomChip';
import { Code } from 'models/common/CommonCode';
import { useMechUtTypes } from 'hooks/useMechUtTypes';
import { useUtComparisonStore } from '../store/useUtComparisonStore';
import { UtKey } from '../types';
import ControlsBar from './ControlsBar';
import SectionBox from './SectionBox';

/** 전체 보기 칩의 값 — UT 항목키와 겹치지 않는다 */
const ALL = 'ALL';

/** ② UT 항목 선택 — 항목 목록은 공통코드(MECH_UT_CTGR_CD)가 정한다 */
const UtTabs = () => {
  const currentUT = useUtComparisonStore((s) => s.currentUT);
  const setCurrentUT = useUtComparisonStore((s) => s.setCurrentUT);
  const utTypes = useMechUtTypes();

  /** CustomChip은 공통코드 모양(cmnCd/cmnCdNm)을 받으므로 UT 항목을 그 형태로 맞춘다 */
  const options: Code[] = useMemo(
    () => [
      { cmnCd: ALL, cmnCdNm: '전체' },
      ...utTypes.map((ut) => ({ cmnCd: ut.key, cmnCdNm: ut.label })),
    ],
    [utTypes]
  );

  return (
    <SectionBox no="②" title="UT 항목 선택">
      <div className="chip-row">
        <CustomChip
          options={options}
          defaultValue={currentUT}
          singleSelect
          /*
              CustomChip은 선택된 칩을 다시 누르면 선택 해제(빈 값)까지 허용한다.
              이 화면에는 "고른 항목이 없는" 상태가 없으므로 해제되면 전체 보기로 되돌린다.
            */
          onChange={(value) => setCurrentUT(((value as string) || ALL) as UtKey | 'ALL')}
        />
      </div>
      {/*
        표시 옵션·산출 버튼을 이 영역 본문에 둔다 — 헤더가 아니라 본문이라야
        "UT 항목 선택"을 접을 때 같이 접힌다.
      */}
      <ControlsBar />
    </SectionBox>
  );
};

export default UtTabs;
